import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Label } from 'semantic-ui-react';

const style = {
  marginBottom: 5,
};

const Hashtags = ({
  value,
}) => {
  const hashtags = _.isArray(value) ? value : _.split((value || ''), ',');
  if (_.isEmpty(hashtags)) return null;
  return (
    <div>
      {
        _.map(hashtags, hashtag => <Label key={hashtag} basic style={style}>{ hashtag }</Label>)
      }
    </div>
  );
};

Hashtags.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
};

export default Hashtags;



/** WEBPACK FOOTER **
 ** ./src/components/hashtags/index.js
 **/